<template>
    <div>
        
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h3 class="mb-0">Pengiriman QR</h3>
            </div>
            <div class="p-2 bd-highlight" style="width: 300px;">
                <div class="row"> 
                    <div class="col-5 mt-auto mb-auto">
                        Saldo QR : 10,000
                    </div>
                    <div class="col-7">
                        <button class="btn shadow w-100 bg-white">
                            <i class="fa fa-file-pdf">&nbsp; Download Template</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <qr-issue 
            class="mt-4"
            @showMetodeModal="modal.showMetodeModal = true"
        />

        <metode-pengiriman-modal 
            v-if="modal.showMetodeModal"
            @closeModal="modal.showMetodeModal = false"
        />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment'
import qrIssue from './children/qrIssue.vue'


import MetodePengirimanModal from './children/MetodePengirimanModal.vue';
export default {
    metaInfo : {
        title : 'QR Issue'
    },
    components : {
        Multiselect,
        MetodePengirimanModal,
        qrIssue
    },
    data () {
        let startDate = moment().startOf('month').format("MM-DD-Y");
        let currentDate = moment().format("MM-DD-Y");
        return {
            rangePickr: {
                mode: 'range',
                dateFormat: "m-d-Y",
                altInput: true,
                altInputClass: 'form-control input bg-white h-47px',
                altFormat : 'm-d-Y'
            },
            selected : {
                date : `${startDate} to ${currentDate}`
            },
            modal : {
                showMetodeModal : false
            }
        }
    },
    methods : {
        showMetodeModal () {
            this.modal.showMetodeModal = true
        }
    }
}
</script>